/*
 * Highlighter
 *
 * Create a highlight for a string. E.g: highlight the unique code from amount.
 */

import { HTMLAttributes } from "react";
import { HighlightText } from "./Highligther.styled";

import { money } from "src/helpers/number";

export type HighlighterProps = HTMLAttributes<HTMLSpanElement> & {
  /**
   * Unique code props
   */
  uniqueCode: number;

  /**
   * Total amount for the transaction
   */
  totalAmount: number;
};

const defaultProps = {
  uniqueCode: 50,
  totalAmount: 100
};

function Highlighter(props: HighlighterProps) {
  const { uniqueCode = 50, totalAmount = 100, ...restProps } = props;
  const amount = totalAmount - uniqueCode;
  const formatedAmount = money(amount); // suppose 'Rp1.100.050'
  const formatedTotalAmount = money(totalAmount); // suppose 'Rp1.100.110' (1100050 + 60 unique code)
  let count = 0;
  // compare and count number of same character from start of both string
  for (let x = 0; x < formatedTotalAmount.length; x++) {
    if (formatedAmount[x] === formatedTotalAmount[x]) {
      count += 1;
    } else {
      // once it found different character, loop will break
      break;
    }
  }

  // get highlighted part by slicing `count` of character ('110')
  const suffix = formatedTotalAmount.slice(count);
  // get character not highlighted ('Rp1.100.') by replacing part of totalAmount with highlighted part
  const prefix = formatedTotalAmount.slice(0, -suffix.length);
  return (
    <>
      {prefix}
      <HighlightText {...restProps}>{suffix}</HighlightText>
    </>
  );
}

Highlighter.defaultProps = defaultProps;

export default Highlighter;
